module.exports = __webpack_public_path__ + "static/media/Lens-Bright_TW.c3280879.png";